import React from 'react'
import FooterAll from '../components/footer2'
import Navbar from '../components/navbar'
import { Link } from 'react-router-dom'
import { Helmet } from 'react-helmet'

function CSR() {
    const canonical = window.location.href.replace(/^https?:\/\/www\./, 'https://');
    return (
        <div>
            <Helmet>
            <title>Saya Homes | Corporate Social Responsibility</title>
            <meta name="description" content="At Saya Homes, we are committed to towards betterment of the society. We are working relentlessly towards welfare of the society through sustainable practices." />
            <meta name="keywords" content="csr, corporate social responsibility" />
            <link rel="canonical" href={canonical}/>
            </Helmet>
            <Navbar />
            <div>
                <div>

                </div> <div className="emptyBox"></div>
                <div className="pageTitle py-5 bg-orange w-100">
                    <div className="container-lg">
                        <h1 className="display-4 mb-0">CSR</h1>
                    </div>
                </div>
                <div className="breadcrumbContainer">
                    <div className="container-lg">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item"><Link to='/'>Home</Link></li>
                            <li className="breadcrumb-item active" aria-current="page">CSR</li>
                        </ol>
                    </div>
                </div>
                <div className="w-100 padding overflow-hidden position-relative hm-overview-container">
                    <div className="container-lg">
                        <div className="heading">
                            <h6 className="text-orange">Corporate Social Responsibility</h6>
                            <h2 className="h1 mb-0 text-serif">A step towards a better world</h2>
                        </div>
                        <div className="overview-text">
                            <div className="inner">
                                <p className="mb-0">At Saya, we strive to maintain responsible relationships with people and continue to deliver real estate of the highest calibre. We are committed to value trust and also ensure that our projects strictly follow sustainable practices for a better tomorrow. We always work towards strengthening the community through noble and exciting initiatives. Here at Saya, we believe it is our responsibility to give as much to our society and lift the community together. For us, a healthy and prosperous nation isn't just a dream, it is a target that can be achieved through sustainable actions in the right direction.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="w-100 padding overflow-hidden bg-secondary-light position-relative">
                <div className="container-lg">
                    <div className="csrBox">
                        <div className="row gap-row">
                            <div className="col-md-4 csr-img">
                                <div className="img-fluid h-100 position-relative">
                                    <img src="https://sayahomes.com/assets/images/csr/20220530110800-Saya-Health-Check-up-2020.webp" className="h-100 object-cover" alt='Saya Homes' />
                                </div>
                            </div>
                            <div className="col-md-8  csr-details">
                                <div className="inner">
                                    <div className="csr-date">Organised: <span>1st</span> Jan 2020</div>
                                    <h3 className="text-serif">Health check-up in association with healing tree hospital at Saya Gold Avenue, Indirapuram (Jan 2020)</h3>
                                    <p className="mb-0">As Saya Homes is always shown concern for their customers, the same concern is shown towards their employees. Saya Homes organized a health check-up camp at Saya Gold Avenue, Indirapuram as the health and well-being of our resources is of supreme importance to us.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="csrBox">
                        <div className="row gap-row">
                            <div className="col-md-4 csr-img">
                                <div className="img-fluid h-100 position-relative">
                                    <img src="https://sayahomes.com/assets/images/csr/20220530110729-WORLD_ENVIRONMENT_DAY,_2018.webp" className="h-100 object-cover" alt='Saya Homes' />
                                </div>
                            </div>
                            <div className="col-md-8 csr-details">
                                <div className="inner">
                                    <div className="csr-date">Organised: <span>5th</span>Jun 2018</div>
                                    <h3 className="text-serif">World environment day, 2018- sapling distribution held at Saya Gold Avenue, Indirapuram</h3>
                                    <p className="mb-0">We, at Saya Homes, believe that Mother Nature should be correctly catered to, we all are her elements and thus; we shall put in our best efforts to make our environment clean and green.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="csrBox">
                        <div className="row gap-row">
                            <div className="col-md-4 csr-img">
                                <div className="img-fluid h-100 position-relative">
                                    <img src="https://sayahomes.com/assets/images/csr/20220530110745-FREE_HEALTH_CHECK-UP_-_2018.webp" className="h-100 object-cover" alt='Saya Homes' />
                                </div>
                            </div>
                            <div className="col-md-8 csr-details">
                                <div className="inner">
                                    <div className="csr-date">Organised: <span>1st</span>Apr 2018</div>
                                    <h3 className="text-serif">Free health check-up in association with metro hospital at Saya Zenith, indirapuram (Apr 2018)</h3>
                                    <p className="mb-0">To help people in taking care of their health, Saya Homes organised a free health check-up in association with Metro Hospital at Saya Zenith, Indirapuram.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="csrBox">
                        <div className="row gap-row">
                            <div className="col-md-4 csr-img">
                                <div className="img-fluid h-100 position-relative">
                                    <img src="https://sayahomes.com/assets/images/csr/20220530110710-WEWILL_-_THIRD_FOOD-2018.webp" className="h-100 object-cover" alt='Saya Homes' />
                                </div>
                            </div>
                            <div className="col-md-8 csr-details">
                                <div className="inner">
                                    <div className="csr-date">Organised: <span>1st</span>Apr 2018</div>
                                    <h3 className="text-serif">Free health check-up in association with metro hospital at Saya Zenith, Indirapuram (Apr 2018)</h3>
                                    <p className="mb-0">To help people in taking care of their health, Saya Homes organised a free health check-up in association with Metro Hospital at Saya Zenith, Indirapuram.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="csrBox">
                        <div className="row gap-row">
                            <div className="col-md-4 csr-img">
                                <div className="img-fluid h-100 position-relative">
                                    <img src="https://sayahomes.com/assets/images/csr/20220530110656-AYURVEDIC_HEALTH_CHECKUP_-_2018.webp" className="h-100 object-cover" alt='Saya Homes' />
                                </div>
                            </div>
                            <div className="col-md-8 csr-details">
                                <div className="inner">
                                    <div className="csr-date">Organised: <span>1st</span>Apr 2018</div>
                                    <h3 className="text-serif">Ayurvedic health checkup camp in association with vedic gram on world health day (Apr 2018)</h3>
                                    <p className="mb-0">Saya Homes organised a free Ayurvedic health checkup camp in association with Vedic Gram on World Health Day. The noble initiative also helped promoting Ayurveda amongst the masses.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="csrBox">
                        <div className="row gap-row">
                            <div className="col-md-4 csr-img">
                                <div className="img-fluid h-100 position-relative">
                                    <img src="https://sayahomes.com/assets/images/csr/20220530110643-ON_WORLD_HEALTH_DAY_-_2018.webp" className="h-100 object-cover" alt='Saya Homes' />
                                </div>
                            </div>
                            <div className="col-md-8 csr-details">
                                <div className="inner">
                                    <div className="csr-date">Organised: <span>1st</span>Apr 2018</div>
                                    <h3 className="text-serif">On world health day, saya homes organised a free dental checkup with clove dental at Saya Gold Avenue (Apr 2018)</h3>
                                    <p className="mb-0">A smile makes you more beautiful and to take care of your smile, Saya Homes on account of world health day has taken the initiative of organising a Free Dental Checkup for all in association with Clove Dental at Saya Gold Avenue on 6th April from 11 a.m onwards.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="csrBox">
                        <div className="row gap-row">
                            <div className="col-md-4 csr-img">
                                <div className="img-fluid h-100 position-relative">
                                    <img src="https://sayahomes.com/assets/images/csr/20220530110620-WEWILL_-_SECOND_FOOD-2018.webp" className="h-100 object-cover" alt='Saya Homes' />
                                </div>
                            </div>
                            <div className="col-md-8 csr-details">
                                <div className="inner">
                                    <div className="csr-date">Organised: <span>1st</span>Apr 2018</div>
                                    <h3 className="text-serif">#Wewill - second food donation drive by Saya foundation (Apr 2018)</h3>
                                    <p className="mb-0">Saya Homes have taken a pledge to spread smiles and help those in need. The SECOND FOOD DONATION at SAYA S className drive by Saya Foundation witnessed the presence of thousands of people. The initiative is getting stronger with every passing week.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="csrBox">
                        <div className="row gap-row">
                            <div className="col-md-4 csr-img">
                                <div className="img-fluid h-100 position-relative">
                                    <img src="https://sayahomes.com/assets/images/csr/20220530110620-WEWILL_-_SECOND_FOOD-2018.webp" className="h-100 object-cover" alt='Saya Homes' />
                                </div>
                            </div>
                            <div className="col-md-8 csr-details">
                                <div className="inner">
                                    <div className="csr-date">Organised: <span>1st</span>Mar 2018</div>
                                    <h3 className="text-serif">#Wewill - first food donation drive by Saya foundation (Mar 2018)</h3>
                                    <p className="mb-0">The FIRST FOOD DONATION drive by Saya Foundation took place at SAYA GOLD AVENUE. The initiative is to bring a smile on the faces of people who are in need. The food donation drive will continue for three months at various locations in Ghaziabad.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="csrBox">
                        <div className="row gap-row">
                            <div className="col-md-4 csr-img">
                                <div className="img-fluid h-100 position-relative">
                                    <img src="https://sayahomes.com/assets/images/csr/20220530110553-GIVING_A_WARM_HUG_-_2017.webp" className="h-100 object-cover" alt='Saya Homes' />
                                </div>
                            </div>
                            <div className="col-md-8 csr-details">
                                <div className="inner">
                                    <div className="csr-date">Organised: <span>1st</span>Dec 2017</div>
                                    <h3 className="text-serif">Giving a warm hug to the poor (Dec 2017)</h3>
                                    <p className="mb-0">Saya organised woolen clothes distribution program among underprivileged children at Saya Gold Avenue, Indirapuram</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="csrBox">
                        <div className="row gap-row">
                            <div className="col-md-4 csr-img">
                                <div className="img-fluid h-100 position-relative">
                                    <img src="https://sayahomes.com/assets/images/csr/20220530110325-CHILDRENS_DAY_2017.webp" className="h-100 object-cover" alt='Saya Homes' />
                                </div>
                            </div>
                            <div className="col-md-8 csr-details">
                                <div className="inner">
                                    <div className="csr-date">Organised: <span>1st</span>Nov 2017</div>
                                    <h3 className="text-serif">Children's day 2017 (Nov 2017)</h3>
                                    <p className="mb-0">Saya celebrated Children's Day 2017 with underprivileged children with Art and Craft at Saya Gold Avenue, Indirapuram.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="csrBox">
                        <div className="row gap-row">
                            <div className="col-md-4 csr-img">
                                <div className="img-fluid h-100 position-relative">
                                    <img src="https://sayahomes.com/assets/images/csr/20220530110313-GREEN_INDIA_CLEAN_INDIA_-2017.webp" className="h-100 object-cover" alt='Saya Homes' />
                                </div>
                            </div>
                            <div className="col-md-8 csr-details">
                                <div className="inner">
                                    <div className="csr-date">Organised: <span>1st</span>Apr 2017</div>
                                    <h3 className="text-serif">Green india clean India (Apr 2017)</h3>
                                    <p className="mb-0">Saya frequently organises activities to keep the surroundings clean, neat and pollution-free. The group takes extra measures to control dust at construction sites. One way Saya ensures to curb pollution is by planting enough trees in the neighbourhoods adjoining to their construction sites. Let's create a better India.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="csrBox">
                        <div className="row gap-row">
                            <div className="col-md-4 csr-img">
                                <div className="img-fluid h-100 position-relative">
                                    <img src="https://sayahomes.com/assets/images/csr/20220530110151-SWACHH_INDIRAPURAM_-2016.webp" className="h-100 object-cover" alt='Saya Homes' />
                                </div>
                            </div>
                            <div className="col-md-8 csr-details">
                                <div className="inner">
                                    <div className="csr-date">Organised: <span>1st</span>Dec 2016</div>
                                    <h3 className="text-serif">Swachh Indirapuram Swasth Indirapuram (Dec 2016)</h3>
                                    <p className="mb-0">This 5 day activity was a CSR initiative by Saya Homes in association with GDA which took place from 8th to 12th December, 2016 to clean up the streets of Indirapuram.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="csrBox">
                        <div className="row gap-row">
                            <div className="col-md-4 csr-img">
                                <div className="img-fluid h-100 position-relative">
                                    <img src="https://sayahomes.com/assets/images/csr/20220530105250-SHARE_WOOLENS_SHARE_WARMTH_-_2016.webp" className="h-100 object-cover" alt='Saya Homes' />
                                </div>
                            </div>
                            <div className="col-md-8 csr-details">
                                <div className="inner">
                                    <div className="csr-date">Organised: <span>1st</span>Aug 2016</div>
                                    <h3 className="text-serif">Share woolens share warmth (Aug 2016)</h3>
                                    <p className="mb-0">This 2 day activity was a CSR initiative by Saya Homes, for the under privileged which took place on 12th and 13th August, 2016.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row no-gutters">
                        <div className="col-lg-6 gridBoxText bg-white d-flex align-items-center">
                            <div className="inner p-5">
                                <div className="heading">
                                    <h2 className="h1 text-serif text-orange mb-0">Environmental Stewardship</h2>
                                </div>
                                <p className="mb-0">Unlike others in the real estate industry, Saya goes an extra mile to ensure environmental protection & conservation. We have adapted various eco-friendly processes and have undertaken green initiatives in all aspects of construction. We take pride in developing energy-efficient and eco-friendly residential solutions which allow our patrons to experience a "green & clean" lifestyle.</p>
                            </div>
                        </div>
                        <div className="col-lg-6 gridBoxImg">
                            <img src="https://sayahomes.com/assets/images/csr.webp" className="h-100 object-cover" alt='Saya Homes' />
                        </div>
                    </div>
                </div>
            </div>
            <div className="logo-icon"><img src="https://sayahomes.com/assets/images/logo-icon.svg" alt="Saya Logo" title='Saya Logo'/></div>
            <FooterAll />
        </div>


    )
}

export default CSR